import { jsx as l } from "react/jsx-runtime";
import { createContext as L, useState as d, useEffect as r, useContext as m } from "react";
import n from "../i18n/index.js";
const g = L(null);
function v(a) {
  const {
    language: t = "auto",
    languageResources: u = [],
    children: i
  } = a, [s, c] = d(t);
  r(() => {
    o(t);
  }, [t]), r(() => {
    u.forEach((e) => {
      n.addResourceBundle(e.lng, "translation", e.translation, !0, !1);
    });
  }, [u]);
  function o(e) {
    e === "auto" ? n.changeLanguage() : n.changeLanguage(e), c(e);
  }
  const f = {
    language: s,
    setLanguage: o,
    t: n.t,
    i18n: n
  };
  return /* @__PURE__ */ l(g.Provider, { value: f, children: i });
}
function w() {
  const a = m(g);
  if (!a)
    throw new Error("useLanguage must be used within a LanguageProvider");
  return a;
}
export {
  v as LanguageProvider,
  w as useLanguage
};
